import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { AbstractPickedFile, CloudPickedFile } from 'app/models/picked-file';
import { PrefixSuffixBuilderComponent } from 'app/views/prefix-suffix-builder/prefix-suffix-builder.component';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-add-edit-report-auto-upload',
  templateUrl: './add-edit-report-auto-upload.component.html',
  styleUrls: ['./add-edit-report-auto-upload.component.scss']
})
export class AddEditReportAutoUploadComponent implements OnInit {

  @Input() isEdit: boolean;
  @Output() addEditAccepted: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  autoUploadRuleToAddFormGroup: FormGroup;

  @ViewChild('addEditAutoUploadModal', { static: true }) addEditAutoUploadModal: ModalDirective;
  @ViewChild('prefixBuilder', { static: false }) prefixBuilder: PrefixSuffixBuilderComponent;
  @ViewChild('suffixBuilder', { static: false }) suffixBuilder: PrefixSuffixBuilderComponent;

  constructor(private validationHandler: ValidationHandler) { }

  ngOnInit(): void {
  }

  show(frm: FormGroup) {
    this.autoUploadRuleToAddFormGroup = frm;
    this.addEditAutoUploadModal.show();
  }

  onAddAutoUploadModalAddClick() {
    this.validationHandler.onSubmitCheck(this.autoUploadRuleToAddFormGroup);
    if(!this.autoUploadRuleToAddFormGroup.valid){
      return;
    }

    this.addEditAccepted.emit(this.autoUploadRuleToAddFormGroup);
    this.addEditAutoUploadModal.hide();
  }

  onPickedDestination(e: AbstractPickedFile[]) {
    let cloudPickedFolder = e[0] as CloudPickedFile;
    this.autoUploadRuleToAddFormGroup.get('storage_id').setValue(cloudPickedFolder.storageId);
    this.autoUploadRuleToAddFormGroup.get('path').setValue(cloudPickedFolder.path);

  }
}
